import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bloodhound = defineConnector({
  identifier: "bloodhound",
  name: "BloodHound",
  tagLine: "AD attack path analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.bloodhoundenterprise\\.io/.*",
  auth: customAuth("bloodhound"),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [BloodHound Enterprise](https://bloodhoundenterprise.io/) tenant and click the cog icon in the top right corner, then go to **API Explorer**. Create a new API token from the token management section.",
        },
      ],
    },
    {
      title: "Enter your tenant URL",
      items: [
        {
          kind: "hostname",
          label: "Tenant URL",
          placeholder: "your-tenant.bloodhoundenterprise.io",
          required: true,
          target: { kind: "configuration", field: "tenantUrl" },
          helperText: "Your BloodHound Enterprise tenant URL.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API token ID",
          required: true,
          target: { kind: "secrets", field: "tokenId" },
        },
        {
          kind: "input",
          label: "API token key",
          required: true,
          target: { kind: "secrets", field: "tokenKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ tenantUrl }) => `https://${tenantUrl}/api/v2/self`,
  },
  publicEnvVars: ({ tenantUrl }) => ({
    BLOODHOUND_URL: tenantUrl ? `https://${tenantUrl}` : "",
  }),
});
